<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Customer Name</label>
                  <input type="text"  v-model="form.customername"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Mobile</label>
                  <InternationalPhoneInput
                    ref="mobileInput"
                    v-model="form.mobile"
                    :submitted="phoneSubmitted"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>GST No</label>
                  <input type="text"  v-model="form.gstno"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <input type="text"  v-model="form.address"/>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Update</a>
                <router-link to="customerlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import InternationalPhoneInput from "@/components/InternationalPhoneInput.vue";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  components: { InternationalPhoneInput },
  data() {
    return {
      form: {
        customername: '',
        mobile: '',
        gstno: '',
        address: '',
      },
      phoneSubmitted: false,
      filter: true,
      id: this.$route.query.id,
      title: "Edit Customer",
      title1: "Edit",
    };
  },
  methods: {
    postData() {
      if (!this.form.customername) {
        Swal.fire("Please enter the customer name");
        return;
      }
      this.phoneSubmitted = true;
      if (!this.$refs.mobileInput.validate()) {
        Swal.fire("Please enter a valid mobile number");
        return;
      }
      axios
      .put('/v1/customers/' + this.id, this.form)
      .then(response => {
        Swal.fire("Customer updated successfully");
        this.$router.push({ path: '/customerlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
    },
    async getCustomerById(id) {
      axios
      .get('/v1/customers/'+id)
      .then(response => {
        this.form = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    }
  },
  beforeMount() {
    this.id = this.$route.query.id
    this.getCustomerById(this.id);
  },
  name: "editcustomer",
};
</script>

